





















import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import CheckoutReviewViewModel from "@/chipply/view-model/CheckoutReviewViewModel";

@Component
export default class CheckoutBillingSummary extends Vue {
    public name = "CheckoutBillingSummary";

    @Prop({ type: Object })
    public vm!: CheckoutReviewViewModel;

    private formatPhone(phoneNumberString: string) {
        var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
    }
}
